import React, { useState, useEffect } from "react";
import {
  Image,
  ImageBackground,
  Modal,
  Platform,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import typo from "../../Theme/Typo";
import Colors from "../../Theme/Colors";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Checkbox, TextInput } from "react-native-paper";
import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import Queries from "../../api/queries";
import LoadingModal from "../LoadingModal";
import Button from "../Button";
import Mutation from "../../api/mutation";
import RootStore from "../../Store";
import AntDesign from "@expo/vector-icons/AntDesign";
import ImageViewer from "react-native-image-zoom-viewer";
import Entypo from "@expo/vector-icons/Entypo";
import { parseISO, set, isEqual, differenceInDays } from "date-fns";

import * as ImagePicker from "expo-image-picker";

import { CheckBox } from 'react-native-web';

// NEW CAMERA SCREEN
import CameraScreen from "../CameraScreen";
import ModalQLerr from "../../utils/ModalQLerr";
import AlertCustom from "../utils/alert";

const BG_PATH = require("../../../assets/newDesign/background-portrait.png");

const { userInfo } = RootStore.getInstance();

const DATE_DELTA: number = 3;

const TodoBooking = ({ navigation, route }) => {
  const [QLerror, setQLerror] = useState("");

  const [booking, setBooking] = useState({});
  const [todoList, setTodoList] = useState([]);
  const [nbOfTodoNotFinish, setNbOfTodoNotFinish] = useState<Number>(0);
  const [isFinish, setFinish] = useState<Boolean>(false);
  const [isDone, setDone] = useState<Boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [eventDetail, setEventDetails] = useState({});

  const [checkoutInfo, setCheckoutInfo] = useState({});
  const [fullView, setFullView] = useState(false);

  const [checkoutInfoFetched, setCheckoutInfoFetched] = useState(false);

  // Pictures
  // const [MediaAvailable, setMediaAvailable] = useState(false); -> not used here !!!
  const [CameraOpen, setCameraOpen] = useState(false);
  const [pictures, setPictures] = useState<Array<any>>([]);
  const [commentary, setCommentary] = useState<string>("");
  const [isViewer, setViewer] = useState({
    isVisible: false,
    index: 0,
  });

  const queries = new Queries();
  const mutation = new Mutation();

  const { eventId = "" } = route.params;

  const { t, i18n } = useTranslation();

  const getEventDetails = async () => {
    setLoading(true);
    try {
      const data = await queries.getEventDetail(eventId, i18n.language);

      let errors = data?.errors;

      if (errors && errors.length > 0) {
        const errorMessage: string = errors[0].message;

        setQLerror(errorMessage);
      } else {
        const { booking, todoListAppart, eventDetail } =
          data.data.getDetailOfEvent;
        setBooking(booking);
        setTodoList(
          todoListAppart.map((todo) => ({ text: todo.text, checked: false }))
        );
        if (eventDetail.type == "maintainer") {
          setNbOfTodoNotFinish(0);
          const todoFinished = [];
          for (let todo of todoList) {
            todoFinished.push({
              text: todo.text,
              checked: true,
            });
          }
          checkAblesubmit(todoFinished);
        } else {
          setNbOfTodoNotFinish(todoListAppart?.length);
        }
        /* console.log('detailEvent', eventDetail); */
        setEventDetails(eventDetail);
        //console.log('eventDetail', eventDetail);
        if (
          eventDetail?.statusOfEvent?.find(
            (element) => element.value == "Fini"
          ) ||
          eventDetail?.finish
        ) {
          setDone(true);
        }
        if (todoListAppart.length == 0) {
          setFinish(true);
        }
      }
    } catch (err) {
      setQLerror(err);
    } finally {
      setLoading(false);
    }
  };

  const getCheckoutDetails = async () => {
    setLoading(true);
    //console.log('eventId', eventId);
    const data = await queries.getCheckoutDetails(eventId);
    const checkout = data.data.getCheckoutDetails;
    setCheckoutInfo(checkout);
    if (checkout.checkoutDone) {
      setCheckoutInfoFetched(true);
    }
    /* console.log('checkout', checkout) */
    setLoading(false);
  };

  useEffect(() => {
    if (eventId != "") {
      getEventDetails();
      getCheckoutDetails();
    }
  }, []);

  const checkAblesubmit = (newData) => {
    const notFinish = newData.filter((element) => element.checked == false);
    if (eventDetail.type == "maintainer") {
      setNbOfTodoNotFinish(0);
    } else {
      setNbOfTodoNotFinish(notFinish.length);
    }
    if (notFinish.length == 0) {
      setFinish(true);
    } else {
      setFinish(false);
    }
  };

  const addPicture = (picture: object) => {
    const temp = [...pictures];
    if (picture?.assets?.[0]) temp.push({ uri: picture.assets[0].uri, base64: picture.assets[0].base64 });
    setPictures(temp);
  };

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: false,
      base64: true,
      quality: 0.5,
      exif: true,
    });
    // check date taken
    if (result && result.exif) {
      if (result.exif.DateTimeOriginal && result.exif.DateTimeOriginal !== "") {
        const split = result.exif.DateTimeOriginal.split(" ");
        let date = split[0].split(":");
        let hour = split[1].split(":");

        // for 20/01/2020 12:00:00 -> date = ['2020', '01', '20'], hour = ['12', '00', '00']
        if (
          differenceInDays(
            new Date(),
            new Date(date[0], date[1] - 1, date[2], hour[0], hour[1], hour[2])
          ) > DATE_DELTA
        ) {
          AlertCustom(
            t("VALIDATION_PICTURE_OUT_OF_DATE"),
            t("VALIDATION_PICTURE_OUT_OF_DATE_CONTENT")
          );
          setLoading(false);
          return;
        }
      }
    }
    if (!result.canceled) {
      setLoading(true);
      addPicture(result);
    }
    setLoading(false);
  };

  const tryToGoToEdition = () => {
    if (!checkEditAbility()) {
      AlertCustom(t("VALIDATION_PICTURE_MISSING"), t("OUT_OF_RANGE_EDITION"));
    } else {
      navigation.navigate("EditHistoryEvent", {
        eventId,
        evenDetailParams: eventDetail,
      });
    }
  };

  const MultiselectCheckbox = ({ options, onChange }) => {
    const toggle = (index) => {
      const newData = [...options];
      newData.splice(index, 1, {
        text: options[index].text,
        checked: !options[index].checked,
      });
      onChange(newData);
      checkAblesubmit(newData);
    };

    return (
      <>
        {options.map((item, index) => (
          <View style={style.item} key={index}>
            {Platform.OS !== "web" ? <Checkbox.Android
              color="#71d200"
              uncheckedColor="red"
              status={item.checked ? "checked" : "unchecked"}
              onPress={() => toggle(index)}
            /> :
              <CheckBox
                color="#71d200"
                value={item.checked}
                onChange={() => toggle(index)}
                style={{ marginRight: 10 }}
              />
            }
            <Text style={style.textCheckBox} key={item.text}>
              {item.text}
            </Text>
          </View>
        ))}
      </>
    );
  };

  const checkEditAbility = (): boolean => {
    const currentDate = set(new Date(), {
      hours: 12,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    });
    const endDate = set(parseISO(eventDetail.end), {
      hours: 12,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    });

    //console.log(!isEqual(endDate, currentDate), currentDate, endDate);
    return isEqual(endDate, currentDate);
  };

  const submitEvent = async (isCorrect: boolean) => {
    if (isCorrect) {
      if (!checkEditAbility()) {
        console.log(t("EVENT_VALIDATION_NOT_SAME_DAY_TITLE"),
          t("EVENT_VALIDATION_NOT_SAME_DAY"),)
        AlertCustom(
          t("EVENT_VALIDATION_NOT_SAME_DAY_TITLE"),
          t("EVENT_VALIDATION_NOT_SAME_DAY"),
          [
            {
              text: "Annuler",
              style: "cancel",
            },
            {
              text: "Valider",
              onPress: async () => await submit(),
            },
          ]
        );
      } else {
        await submit();
      }
    } else {
      console.log(t("EVENT_VALIDATION_MISSING_PICTURE"))
      AlertCustom(t("ERROR"), t("EVENT_VALIDATION_MISSING_PICTURE"));
    }
  };

  const submit = async () => {
    if (pictures.length > 0) {
      setLoading(true);
      try {
        const data = await mutation.finishEvent(
          eventId,
          todoList,
          userInfo.getToken(),
          commentary,
          pictures.map((picture) =>
            picture.base64 ? picture.base64 : picture.uri
          )
        );

        let errors = data?.errors;

        if (errors && errors.length > 0) {
          const errorMessage: string = errors[0].message;

          setQLerror(errorMessage);
        } else {
          getEventDetails();
        }
      } catch (err) {
        setQLerror(err);
      }
    } else {
      alert(t("EVENT_VALIDATION_MISSING_PICTURE"));
    }
  };

  const changeDisplayStatus = () => {
    if (fullView) {
      setFullView(false);
    } else if (!fullView) {
      setFullView(true);
    }
  };

  const helpEventInfo = () => {
    AlertCustom(t("EVENT_STATUS_TITLE"), t("HELP_EVENT_INFO"));
  };

  const helpTodoInfo = () => {
    AlertCustom(t("EVENT_TODO_TITLE"), t("HELP_TODO_INFO"));
  };

  const helpIncidentInfo = () => {
    AlertCustom(t("EVENT_PROBLEM_TITLE"), t("HELP_INCIDENT_INFO"));
  };

  const helpCheckoutInfo = () => {
    AlertCustom(t("EVENT_CHECKOUT_TITLE"), t("HELP_CHECKOUT_EVENT_INFO"));
  };

  const deletePicture = (index: any) => {
    AlertCustom(
      t("RERMOVE_ACHAT_CONFIRM_TITLE"),
      t("RERMOVE_PICTURE_CONFIRM_BODY"),
      [
        // The "Yes" button
        {
          text: t("RERMOVE_ACHAT_CONFIRM_YES"),
          onPress: () => {
            const temp = [...pictures];
            temp.splice(index, 1);
            setPictures(temp);
          },
        },
        // The "No" button
        {
          text: t("RERMOVE_ACHAT_CONFIRM_FALSE"),
        },
      ]
    );
  };

  const getReduceText = () => {
    return (
      <Text
        style={{ textAlignVertical: "center", flex: 1, alignItems: "center" }}
      >
        {t("EVENT_REDUCE_BUTTON_TEXT")} ▲
      </Text>
    );
  };

  const getUpgradeText = () => {
    return (
      <Text
        style={{ textAlignVertical: "center", flex: 1, alignItems: "center" }}
      >
        {t("EVENT_DEPLOY_BUTTON_TEXT")} ▼
      </Text>
    );
  };

  return (
    <SafeAreaView style={typo.mainBackground}>
      <ImageBackground source={BG_PATH} style={typo.background}>
        <ScrollView>
          <Modal
            visible={CameraOpen}
            onRequestClose={() => setCameraOpen(false)}
          >
            <CameraScreen
              closeCamera={() => setCameraOpen(false)}
              isChat={false}
              pictures={pictures}
              setPictures={setPictures}
            />
          </Modal>

          {QLerror && QLerror !== "" ? (
            <ModalQLerr reason={QLerror} resetErr={() => setQLerror("")} />
          ) : null}

          {isLoading && <LoadingModal loading={isLoading || isLoading} />}

          <View style={typo.container}>
            <Text style={typo.titleInfo}>{t("EVENT_TITLE")}</Text>
            {!isDone ? (
              <View>
                <View style={typo.resCard}>
                  <View style={typo.underlineCat}>
                    <MaterialIcons
                      name="info"
                      size={24}
                      style={{ marginRight: 10 }}
                      color={Colors.oiqia}
                      onPress={() => helpEventInfo()}
                    />
                    <Text style={typo.category}>{t("EVENT_STATUS_TITLE")}</Text>
                  </View>
                  <View>
                    {eventDetail.type === "cleaner" && (
                      <View>
                        <Text style={[typo.h1, style.newTitle]}>
                          <MaterialIcons
                            style={{ marginRight: 10 }}
                            name="cleaning-services"
                            size={20}
                            color={Colors.oiqia}
                          ></MaterialIcons>{" "}
                          {eventDetail.title}
                        </Text>
                      </View>
                    )}
                    {eventDetail.type === "maintainer" && (
                      <View>
                        <Text style={[typo.h1, style.newTitle]}>
                          <MaterialIcons
                            style={{ marginRight: 10 }}
                            name="build"
                            size={20}
                            color={Colors.oiqia}
                          ></MaterialIcons>{" "}
                          {eventDetail.title}
                        </Text>
                      </View>
                    )}
                    {eventDetail.type === "other" && (
                      <View>
                        <Text style={[typo.h1, style.newTitle]}>
                          <MaterialIcons
                            style={{ marginRight: 10 }}
                            name="flag"
                            size={20}
                            color={Colors.oiqia}
                          ></MaterialIcons>{" "}
                          {eventDetail.title}
                        </Text>
                      </View>
                    )}
                    <View style={{ marginTop: 3 }}>
                      <Text style={typo.body}>
                        <MaterialIcons
                          name="location-pin"
                          size={18}
                          color={Colors.black}
                        ></MaterialIcons>
                        {eventDetail.nameOfAppart}
                      </Text>
                    </View>
                  </View>
                  {eventDetail.description != "" && (
                    <View style={{ marginTop: 5, marginBottom: 5 }}>
                      <Text style={style.newDesc}>
                        {eventDetail.description}
                      </Text>
                    </View>
                  )}
                  <View style={style.columnNew}>
                    <View style={style.left}>
                      <MaterialIcons
                        name="calendar-today"
                        color={Colors.oiqia}
                        size={20}
                      ></MaterialIcons>
                    </View>
                    <View style={style.right}>
                      <Text style={style.newDate}>
                        {eventDetail.start && eventDetail.end && (
                          <Text>
                            {format(
                              new Date(eventDetail?.start),
                              "dd/MM/yyyy "
                            )}
                            {format(new Date(eventDetail?.start), "HH:mm")} →{" "}
                            {format(new Date(eventDetail?.end), "HH:mm")}
                          </Text>
                        )}
                      </Text>
                    </View>
                  </View>
                  {eventDetail.statusOfEvent &&
                    eventDetail?.statusOfEvent[
                      eventDetail?.statusOfEvent.length - 1
                    ].value === "Évènement confirmé" && (
                      <View style={style.columnNew}>
                        <View style={style.left}>
                          <MaterialIcons
                            name="event-available"
                            size={20}
                            color={Colors.green}
                          />
                        </View>
                        <View style={style.right}>
                          <Text style={{ color: Colors.green }}>
                            {
                              eventDetail?.statusOfEvent[
                                eventDetail?.statusOfEvent.length - 1
                              ].value
                            }
                          </Text>
                        </View>
                      </View>
                    )}
                  {eventDetail.statusOfEvent &&
                    eventDetail?.statusOfEvent[
                      eventDetail?.statusOfEvent.length - 1
                    ].value === "Créé" && (
                      <View style={style.columnNew}>
                        <View style={style.left}>
                          <MaterialIcons
                            name="create"
                            size={20}
                            color={Colors.grey}
                          />
                        </View>
                        <View style={style.right}>
                          <Text style={{ color: Colors.grey }}>
                            {
                              eventDetail?.statusOfEvent[
                                eventDetail?.statusOfEvent.length - 1
                              ].value
                            }
                          </Text>
                        </View>
                      </View>
                    )}
                  {eventDetail.statusOfEvent &&
                    eventDetail?.statusOfEvent[
                      eventDetail?.statusOfEvent.length - 1
                    ].value === "Incident déclaré" && (
                      <View style={style.columnNew}>
                        <View style={style.left}>
                          <MaterialIcons
                            name="report-problem"
                            size={20}
                            color={Colors.red}
                          />
                        </View>
                        <View style={style.right}>
                          <Text style={{ color: Colors.red }}>
                            {
                              eventDetail?.statusOfEvent[
                                eventDetail?.statusOfEvent.length - 1
                              ].value
                            }
                          </Text>
                        </View>
                      </View>
                    )}
                  {eventDetail.statusOfEvent &&
                    eventDetail?.statusOfEvent[
                      eventDetail?.statusOfEvent.length - 1
                    ].value === "Fini" && (
                      <View style={style.columnNew}>
                        <View style={style.left}>
                          <MaterialIcons
                            name="check-circle-outline"
                            size={20}
                            color={Colors.green}
                          />
                        </View>
                        <View style={style.right}>
                          <Text style={{ color: Colors.green }}>
                            {
                              eventDetail?.statusOfEvent[
                                eventDetail?.statusOfEvent.length - 1
                              ].value
                            }
                          </Text>
                        </View>
                      </View>
                    )}
                  {eventDetail.statusOfEvent &&
                    eventDetail?.statusOfEvent[
                      eventDetail?.statusOfEvent.length - 1
                    ].value === "Annulé" && (
                      <View style={style.columnNew}>
                        <View style={style.left}>
                          <MaterialIcons
                            name="cancel"
                            size={24}
                            color={Colors.red}
                          />
                        </View>
                        <View style={style.right}>
                          <Text style={{ color: Colors.red }}>
                            {
                              eventDetail?.statusOfEvent[
                                eventDetail?.statusOfEvent.length - 1
                              ].value
                            }
                          </Text>
                        </View>
                      </View>
                    )}
                </View>
                {eventDetail && eventDetail.type == "cleaner" && (
                  <View style={typo.resCard}>
                    <View style={typo.underlineCat}>
                      <MaterialIcons
                        name="bookmark-outline"
                        size={24}
                        style={{ marginRight: 10 }}
                        color={Colors.oiqia}
                        onPress={() => helpCheckoutInfo()}
                      />
                      <Text style={typo.category}>
                        {t("EVENT_CHECKOUT_TITLE")}
                      </Text>
                    </View>
                    <Text style={{ marginTop: 5 }}>
                      {t("EVENT_CHECKOUT_STATUS")}
                      {checkoutInfo.checkoutDone &&
                        checkoutInfo.problem.description == "" &&
                        checkoutInfo.problem.image.length == 0 && (
                          <Text
                            style={{
                              color: Colors.green,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {" "}
                            {t("CHECKOUT_DONE")}{" "}
                          </Text>
                        )}
                      {checkoutInfo.checkoutDone &&
                        checkoutInfo.problem &&
                        (checkoutInfo.problem.description != "" ||
                          checkoutInfo.problem.image.length > 0) && (
                          <Text
                            style={{
                              color: Colors.orange,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {" "}
                            {t("CHECKOUT_DONE_INCIDENT")}{" "}
                          </Text>
                        )}
                      {!checkoutInfo.checkoutDone && (
                        <Text
                          style={{
                            color: Colors.red,
                            fontWeight: "bold",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          {t("CHECKOUT_UNDONE")}{" "}
                        </Text>
                      )}
                    </Text>
                    <Text style={{ marginTop: 5 }}>
                      {t("CHECKOUT_RATING_CLEANNESS")}
                      {checkoutInfo.ratingCleanness != undefined &&
                        checkoutInfo.ratingCleanness == 5 &&
                        checkoutInfo.checkoutDone && (
                          <Text
                            style={{
                              color: Colors.oiqia,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {checkoutInfo.ratingCleanness}/5
                          </Text>
                        )}
                      {checkoutInfo.ratingCleanness != undefined &&
                        checkoutInfo.ratingCleanness >= 3 &&
                        checkoutInfo.ratingCleanness < 5 &&
                        checkoutInfo.checkoutDone && (
                          <Text
                            style={{
                              color: Colors.oiqia,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {checkoutInfo.ratingCleanness}/5
                          </Text>
                        )}
                      {checkoutInfo.ratingCleanness != undefined &&
                        checkoutInfo.ratingCleanness <= 2 &&
                        checkoutInfo.ratingCleanness > 0 &&
                        checkoutInfo.checkoutDone && (
                          <Text
                            style={{
                              color: Colors.oiqia,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {checkoutInfo.ratingCleanness}/5
                          </Text>
                        )}
                      {checkoutInfo.ratingCleanness != undefined &&
                        checkoutInfo.ratingCleanness == 0 &&
                        checkoutInfo.checkoutDone && (
                          <Text
                            style={{
                              color: Colors.red,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {checkoutInfo.ratingCleanness}/5
                          </Text>
                        )}
                      {!checkoutInfo.checkoutDone && (
                        <Text
                          style={{
                            color: Colors.red,
                            fontWeight: "bold",
                            alignItems: "center",
                          }}
                        >
                          {t("UNKNOWN_UNDONE")}
                        </Text>
                      )}
                    </Text>
                    {fullView && (
                      <>
                        <Text>
                          {t("CHECKOUT_RATING_APPART")}
                          <Text
                            style={{
                              color: Colors.oiqia,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {checkoutInfo.ratingAppart}/5
                          </Text>
                        </Text>
                        <Text>
                          {t("CHECKOUT_RATING_OIQIA")}
                          <Text
                            style={{
                              color: Colors.oiqia,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {checkoutInfo.ratingOiqia}/5
                          </Text>
                        </Text>
                      </>
                    )}
                    <Text style={{ marginTop: 5 }}>
                      {t("CHECKOUT_FEEDBACK")}
                      {checkoutInfo.feedBack != undefined &&
                        checkoutInfo.feedBack.length > 20 &&
                        fullView &&
                        checkoutInfo.checkoutDone && (
                          <Text
                            style={{
                              color: Colors.grey,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {checkoutInfo.feedBack}
                          </Text>
                        )}
                      {checkoutInfo.feedBack != undefined &&
                        checkoutInfo.feedBack.length > 20 &&
                        !fullView &&
                        checkoutInfo.checkoutDone && (
                          <Text
                            style={{
                              color: Colors.grey,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {checkoutInfo.feedBack.substring(0, 12)} ...
                          </Text>
                        )}
                      {checkoutInfo.feedBack != undefined &&
                        checkoutInfo.feedBack.length < 20 &&
                        checkoutInfo.checkoutDone && (
                          <Text
                            style={{
                              color: Colors.grey,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {checkoutInfo.feedBack}
                          </Text>
                        )}
                      {checkoutInfo.feedBack != undefined &&
                        checkoutInfo.feedBack == "" &&
                        checkoutInfo.checkoutDone && (
                          <Text
                            style={{
                              color: Colors.red,
                              fontWeight: "bold",
                              alignItems: "center",
                            }}
                          >
                            {t("UNKNOWN")}
                          </Text>
                        )}
                      {!checkoutInfo.checkoutDone && (
                        <Text
                          style={{
                            color: Colors.red,
                            fontWeight: "bold",
                            alignItems: "center",
                          }}
                        >
                          {t("UNKNOWN_UNDONE")}
                        </Text>
                      )}
                    </Text>
                    {fullView &&
                      checkoutInfo &&
                      checkoutInfo.problem &&
                      (checkoutInfo.problem.description != "" ||
                        checkoutInfo.problem.image.length > 0) && (
                        <View style={{ marginTop: 10 }}>
                          <Text>
                            {t("CHECKOUT_PICTURE_INCIDENT")}{" "}
                            <Text
                              style={{
                                color: Colors.red,
                                fontWeight: "800",
                                marginBottom: 10,
                              }}
                            >
                              {checkoutInfo.problem.description
                                ? checkoutInfo.problem.description
                                : t("CHECKOUT_INCIDENT_DESCRIPTION_NULL")}
                            </Text>
                          </Text>
                          <View style={typo.catCard}>
                            <ScrollView horizontal>
                              {checkoutInfo.problem.image.length > 0 ? (
                                checkoutInfo.problem.image.map(
                                  (element, index) => (
                                    <View style={{ margin: 5 }} key={index}>
                                      <Image
                                        style={style.image}
                                        source={{ uri: element }}
                                      />
                                    </View>
                                  )
                                )
                              ) : (
                                <View>
                                  <Text
                                    style={[typo.body, { alignSelf: "center" }]}
                                  >
                                    {t("PROBLEM_PICTURES_EMPTY")}
                                  </Text>
                                </View>
                              )}
                            </ScrollView>
                          </View>
                        </View>
                      )}

                    {checkoutInfoFetched && (
                      <Button
                        onPress={() => changeDisplayStatus()}
                        style={{
                          backgroundColor: checkoutInfo.checkoutDone
                            ? Colors.oiqia
                            : Colors.grey,
                          marginTop: 10,
                        }}
                        text={
                          fullView == true ? getReduceText() : getUpgradeText()
                        }
                      />
                    )}
                  </View>
                )}

                {eventDetail.type != "maintainer" &&
                  eventDetail.statusOfEvent &&
                  eventDetail?.statusOfEvent[
                    eventDetail?.statusOfEvent.length - 1
                  ].value != "Annulé" && (
                    <View style={typo.resCard}>
                      <View style={typo.underlineCat}>
                        <MaterialIcons
                          name="done"
                          size={24}
                          style={{ marginRight: 10 }}
                          color={Colors.oiqia}
                          onPress={() => helpTodoInfo()}
                        />
                        <Text style={typo.category}>
                          {t("EVENT_TODO_TITLE")} |{" "}
                          <Text style={{ color: Colors.oiqia }}>
                            {nbOfTodoNotFinish}
                          </Text>
                        </Text>
                      </View>
                      <MultiselectCheckbox
                        options={todoList}
                        onChange={setTodoList}
                      />
                    </View>
                  )}
                {eventDetail.statusOfEvent &&
                  eventDetail?.statusOfEvent[
                    eventDetail?.statusOfEvent.length - 1
                  ].value != "Annulé" && (
                    <View style={typo.resCard}>
                      <View style={typo.underlineCat}>
                        <MaterialIcons
                          name="report-problem"
                          size={24}
                          style={{ marginRight: 10 }}
                          color={Colors.oiqia}
                          onPress={() => helpIncidentInfo()}
                        />
                        <Text style={typo.category}>
                          {t("EVENT_PROBLEM_TITLE")}
                        </Text>
                      </View>
                      {eventDetail.problems &&
                        eventDetail.problems.title != "" ? (
                        <View>
                          <TextInput
                            activeOutlineColor={Colors.oiqia}
                            value={eventDetail.problems.title}
                            label={t("PROBLEM_TITLE_LABEL")}
                            style={{
                              marginTop: 10,
                              marginBottom: 10,
                              backgroundColor: "white",
                            }}
                            mode="outlined"
                            disabled
                          />
                          <TextInput
                            activeOutlineColor={Colors.oiqia}
                            value={eventDetail.problems.description}
                            label={t("PROBLEM_DESCRIPTION_LABEL")}
                            style={{
                              marginTop: 10,
                              marginBottom: 10,
                              backgroundColor: "white",
                            }}
                            mode="outlined"
                            disabled
                          />
                          <View style={typo.catCard}>
                            <ScrollView horizontal>
                              {eventDetail.problems.image.length > 0 ? (
                                eventDetail.problems.image.map(
                                  (element, index) => (
                                    <View style={{ margin: 5 }} key={index}>
                                      <Image
                                        style={style.image}
                                        source={{ uri: element }}
                                      />
                                    </View>
                                  )
                                )
                              ) : (
                                <View style={typo.catCard}>
                                  <Text
                                    style={[typo.body, { alignSelf: "center" }]}
                                  >
                                    {t("PROBLEM_PICTURES_EMPTY")}
                                  </Text>
                                </View>
                              )}
                            </ScrollView>
                          </View>
                        </View>
                      ) : (
                        <View style={[typo.catCard, { width: "100%" }]}>
                          <Text style={[typo.body, { alignSelf: "center" }]}>
                            {t("EVENT_PROBLEM_EMPTY")}
                          </Text>
                        </View>
                      )}
                      {eventDetail.problems &&
                        eventDetail.problems.title == "" ? (
                        <Button
                          text={t("EVENT_PROBLEM_BUTTON")}
                          style={{
                            alignSelf: "center",
                            backgroundColor: Colors.oiqia,
                            marginTop: 10,
                          }}
                          onPress={() =>
                            navigation.navigate("AddProblem", {
                              eventId,
                              refreshPicture: getEventDetails,
                            })
                          }
                        />
                      ) : (
                        <Button
                          text="Modier l'incident"
                          style={{
                            alignSelf: "center",
                            backgroundColor: Colors.oiqia,
                            marginTop: 10,
                          }}
                          onPress={() =>
                            navigation.navigate("AddProblem", {
                              eventId,
                              problem: eventDetail.problems,
                              refreshPicture: getEventDetails,
                            })
                          }
                        />
                      )}
                    </View>
                  )}
                {isFinish &&
                  eventDetail.statusOfEvent &&
                  eventDetail?.statusOfEvent[
                    eventDetail?.statusOfEvent.length - 1
                  ].value != "Annulé" && (
                    <View style={typo.resCard}>
                      <View style={typo.underlineCat}>
                        <MaterialIcons
                          name="info"
                          size={24}
                          style={{ marginRight: 10 }}
                          color={Colors.oiqia}
                        />
                        <Text style={typo.category}>
                          {t("EVENT_FINISH_PRESTA")}
                        </Text>
                      </View>
                      <Text
                        style={[typo.body, { marginBottom: 20, marginTop: 5 }]}
                      >
                        {t("EVENT_FINISH_DETAILS")}
                      </Text>
                      <View style={typo.catCard}>
                        {pictures.length > 0 ? (
                          <ScrollView horizontal>
                            {pictures.map((element, index) => (
                              <View key={index} style={{ margin: 5 }}>
                                <TouchableOpacity
                                  onPress={() =>
                                    setViewer({ isVisible: true, index })
                                  }
                                >
                                  <Image
                                    style={style.image}
                                    source={{ uri: element.uri }}
                                  />
                                </TouchableOpacity>
                                <View style={{ alignSelf: "center" }}>
                                  <FontAwesome
                                    name="trash"
                                    size={24}
                                    color={Colors.red}
                                    onPress={() => deletePicture(index)}
                                  />
                                </View>
                              </View>
                            ))}
                          </ScrollView>
                        ) : (
                          <View style={{ alignSelf: "center" }}>
                            <Text style={typo.body}>
                              {t("PROBLEM_PICTURES_EMPTY")}
                            </Text>
                          </View>
                        )}
                      </View>
                      <View
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-around",
                          marginTop: 10,
                          alignItems: "center",
                        }}
                      >
                        <TouchableOpacity
                          style={style.colImg}
                          onPress={() => setCameraOpen(true)}
                        >
                          <AntDesign
                            name="camera"
                            size={30}
                            color={Colors.oiqia}
                          />
                          <Text>{t("PROBLEM_PICTURE_TAKE")}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={style.colImg}
                          onPress={() => pickImage()}
                        >
                          <AntDesign
                            name="picture"
                            size={30}
                            color={Colors.oiqia}
                          />
                          <Text>{t("PROBLEM_PICTURE_PICK")}</Text>
                        </TouchableOpacity>
                      </View>
                      <View>
                        <TextInput
                          activeOutlineColor={Colors.oiqia}
                          value={commentary}
                          label={t("EVENT_FINISH_PICTURE_COMMENTARY")}
                          style={{
                            marginTop: 10,
                            marginBottom: 10,
                            backgroundColor: "white",
                          }}
                          mode="outlined"
                          onChangeText={setCommentary}
                          multiline
                        />
                      </View>
                      {Platform.OS != "web" && pictures.length > 0 && (
                        <SafeAreaView style={{ flex: 1 }}>
                          <Modal
                            visible={isViewer.isVisible}
                            transparent={true}
                          >
                            <ImageViewer
                              key={isViewer.index}
                              enableSwipeDown={true}
                              index={isViewer.index}
                              imageUrls={pictures.map((ele) => {
                                return {
                                  url: ele.uri,
                                  props: { source: ele.uri },
                                };
                              })}
                              renderHeader={() => (
                                <SafeAreaView>
                                  <TouchableOpacity
                                    onPress={() =>
                                      setViewer({ isVisible: false, index: 0 })
                                    }
                                  >
                                    <Entypo
                                      name="cross"
                                      onPress={() =>
                                        setViewer({
                                          isVisible: false,
                                          index: 0,
                                        })
                                      }
                                      size={60}
                                      color="white"
                                    />
                                  </TouchableOpacity>
                                </SafeAreaView>
                              )}
                            ></ImageViewer>
                          </Modal>
                        </SafeAreaView>
                      )}
                      {pictures.length > 0 && (
                        <Button
                          text={t("EVENT_FINISH_BUTTON")}
                          style={{
                            alignSelf: "center",
                            backgroundColor: Colors.oiqia,
                            marginTop: 10,
                          }}
                          onPress={() => submitEvent(true)}
                        />
                      )}
                      {pictures.length == 0 && (
                        <Button
                          text={t("EVENT_FINISH_BUTTON")}
                          style={{
                            alignSelf: "center",
                            backgroundColor: Colors.lightGrey,
                            marginTop: 10,
                          }}
                          onPress={() => submitEvent(false)}
                        />
                      )}
                    </View>
                  )}
              </View>
            ) : (
              <View>
                <View style={typo.resCard}>
                  <View style={typo.underlineCat}>
                    <MaterialIcons
                      name="info"
                      size={24}
                      style={{ marginRight: 10 }}
                      color={Colors.oiqia}
                    />
                    <Text style={typo.category}>{t("EVENT_DONE_TITLE")}</Text>
                  </View>
                  <Button
                    text={t("EVENT_DONE_BUTTON")}
                    style={{
                      alignSelf: "center",
                      backgroundColor: Colors.oiqia,
                      marginTop: 10,
                    }}
                    onPress={() =>
                      navigation.navigate("HistoryEvent", {
                        bookingParams: booking,
                        todoListParams: todoList,
                        evenDetailParams: eventDetail,
                        checkoutInfo: checkoutInfo,
                      })
                    }
                  />
                  <Button
                    text={t("EVENT_DONE_EDIT_BUTTON")}
                    style={{
                      alignSelf: "center",
                      backgroundColor: checkEditAbility()
                        ? Colors.oiqia
                        : Colors.grey,
                      marginTop: 10,
                    }}
                    onPress={() => tryToGoToEdition()}
                  />
                </View>
              </View>
            )}
          </View>
        </ScrollView>
      </ImageBackground>
    </SafeAreaView>
  );
};

const style = StyleSheet.create({
  newDate: {
    fontWeight: "bold",
    color: Colors.oiqia,
    textAlignVertical: "center",
  },
  newDesc: {
    color: Colors.black,
    fontStyle: "italic",
    fontSize: 18,
  },
  newTitle: {
    color: Colors.oiqia,
  },
  center: {
    flex: 1,
    justifyContent: "flex-end",
  },
  titleWelcome: {
    fontSize: 18,
    color: "black",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "RobotoMedium",
  },
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  colImg: {
    alignItems: "center",
    marginBottom: 15,
    marginTop: 10,
  },
  column: {
    flex: 1,
    alignSelf: "auto",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  columnNew: {
    flex: 1,
    alignSelf: "flex-start",
    flexDirection: "row",
    marginTop: 10,
  },
  left: {
    alignSelf: "flex-start",
  },
  right: {
    marginLeft: 5,
    alignSelf: "flex-end",
  },
  dateInfo: {
    width: "50%",
    padding: 5,
    textAlign: "left",

    justifyContent: "flex-start",
  },
  underline: {
    borderColor: "#0A0A0AE7",
    borderBottomWidth: 0.5,
    paddingBottom: 5,
    marginBottom: 10,
  },
  item: {
    marginTop: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  textCheckBox: {
    maxWidth: 320,
  },
  image: {
    left: 5,
    top: 5,
    width: 200,
    height: 150,
    borderWidth: 1,
    borderRadius: 1,
    marginRight: 10,
    borderColor: "white",
    marginBottom: 5,
  },
  cautionMessage: {
    color: "red",
  },
  inner: {
    padding: 24,
    flex: 1,
    justifyContent: "space-around",
  },
});

export default TodoBooking;
